import { createSlice } from "@reduxjs/toolkit";

const quoteSlice = createSlice({
  name: "quote",
  initialState: {
    showMoreQuotes: {},
    knowMoreData: {},
    showInsurer: false,
    showSumInsurer: false,
    showSortBy: false,
    showEdit: false,
    editMode: "default",
    planName: "",
    compareQuote: [],
    isShareQuotesModalOpen: false,
    shareSelectedQuotes: false,
    quotesToShare: [],
    shortListedQuotes: [],
    showDifference: false,
    showAddCompareModal: false,
    showCompareModal: false,
  },
  reducers: {
    toggleMoreQuotes: (state, action) => {
      state.showMoreQuotes[action.payload.id] = action.payload.value;
    },
    setEditMode: (state, action) => {
      state.editMode = action.payload;
    },
    setKnowMoreData: (state, action) => {
      state.knowMoreData = action.payload;
    },
    setInsurerOpen: (state, action) => {
      state.showInsurer = action.payload;
    },
    setShowSumInsurer: (state, action) => {
      state.showSumInsurer = action.payload;
    },
    setShowSortBy: (state, action) => {
      state.showSortBy = action.payload;
    },
    setShowEdit: (state, action) => {
      state.showEdit = action.payload;
    },
    setCompareQuote: (state, action) => {
      state.compareQuote.push(action.payload);
    },
    removeQuoteFromCompare: (state, action) => {
      state.compareQuote = state.compareQuote.filter(
        (quote) =>
          quote?.data?.[0]?.plan_name !== action.payload?.data?.[0]?.plan_name
      );
    },
    clearCompareQuote: (state) => {
      state.compareQuote = [];
    },
    toggleShareQuotes: (state, action) => {
      state.isShareQuotesModalOpen = action.payload;
    },
    setShareSelectedQuotes: (state, action) => {
      state.shareSelectedQuotes = action.payload;
    },
    setQuotesToShare: (state, action) => {
      state.quotesToShare = action.payload;
    },
    setPlanName: (state, action) => {
      state.planName = action.payload;
    },
    addQuoteToShortlist: (state, action) => {
      if (
        state.shortListedQuotes.some(
          (item) =>
            item.data[0]?.plan_name === action.payload.data[0]?.plan_name
        )
      ) {
        state.shortListedQuotes = state.shortListedQuotes.filter(
          (item) =>
            item.data[0]?.plan_name !== action.payload.data[0]?.plan_name
        );
        return;
      } else {
        state.shortListedQuotes.push(action.payload);
      }
    },
    setShowDifference: (state, action) => {
      state.showDifference = action.payload;
    },
    setShowAddCompareModal: (state, action) => {
      state.showAddCompareModal = action.payload;
    },
    setShowCompareModal: (state, action) => {
      state.showCompareModal = action.payload;
    },
  },
});

export const {
  addQuoteToShortlist,
  setCompareQuote,
  toggleMoreQuotes,
  setKnowMoreData,
  setInsurerOpen,
  setShowSumInsurer,
  setShareSelectedQuotes,
  setShowSortBy,
  setShowEdit,
  clearCompareQuote,
  toggleShareQuotes,
  setQuotesToShare,
  setPlanName,
  setEditMode,
  setShowDifference,
  removeQuoteFromCompare,
  setShowAddCompareModal,
  setShowCompareModal,
} = quoteSlice.actions;

export default quoteSlice.reducer;
